<script>
import Icon from "@/javascript/views/components/Icon.vue";

export default {
  name: "TabsComponent",
  components: {Icon},
  props: {
    /**
     * PROP: modelValue
     * The current active tab's id as a string.
     * Used with v-model to control the active tab.
     **/
    modelValue: {
      type: String,
      default: ""
    },
    /**
     * PROP: tabs
     * An array of tab objects.
     * Each object must have:
     * - id: String (a unique identifier for the tab)
     * - label: String (text label for the tab header)
     **/
    tabs: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      currentTab: this.modelValue,
    };
  },
  watch: {
    modelValue(newVal) {
      this.currentTab = newVal;
    }
  },
  methods: {
    changeTab(tabId) {
      this.currentTab = tabId;
      this.$emit("update:modelValue", tabId);
      this.$emit("tab-changed", tabId);
    },
    beforeEnter(el) {
      el.style.transform = 'translateX(-100%)';
    },
    enter(el, done) {
      el.offsetWidth; // trigger reflow
      el.style.transition = 'transform 0.3s ease-in-out';
      el.style.transform = 'translateX(0)';
      done();
    },
    leave(el, done) {
      el.style.transition = 'transform 0.3s ease-in-out';
      el.style.transform = 'translateX(100%)';
      done();
    }
  }
};
</script>

<template>
  <div class="tabs-component w-full">
    <!-- Only show tab headers if there are multiple tabs -->
    <template v-if="tabs.length > 1">
      <div class="tabs-header flex">
        <button
          v-for="tab in tabs"
          :key="tab.id"
          :class="[
            'flex-1 py-2 text-center transition-colors duration-300',
            currentTab === tab.id ? 'bg-default_primary_dark text-white' : 'bg-white text-gray-500'
          ]"
          @click="changeTab(tab.id)"
        >
          <span class="inline-flex items-center justify-center gap-1">
       <Icon
         v-if="tab.icon"
         :icon="tab.icon"
         :color="tab.iconColor || ''"
         size="16px"
       />
       {{ tab.label }}
     </span>
        </button>
      </div>
    </template>
    <!-- Always render the content -->
    <div class="tabs-content overflow-x-auto">
      <transition
        name="slide"
        @before-enter="beforeEnter"
        @enter="enter"
        @leave="leave"
      >
        <div :key="currentTab">
          <slot :name="currentTab" />
        </div>
      </transition>
    </div>
  </div>
</template>

<style lang="scss">
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.3s ease-in-out;
}
.slide-enter,
.slide-leave-to {
  transform: translateX(100%);
}
</style>
